import { render, staticRenderFns } from "./HorseEvents.vue?vue&type=template&id=f43eb9e2"
import script from "./HorseEvents.vue?vue&type=script&lang=js"
export * from "./HorseEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports